import {actions as A} from '../../constants/actions';

const hideProgressBarPopUp = () => {
  return (dispatch) => {
    dispatch({
      type: A.HIDE_PROGRESS_BAR_POP_UP,
    });
  }
};

export {hideProgressBarPopUp}
